import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {withRouter} from 'react-router';
import _ from 'lodash';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import './Header.css';
import LogoImgSrc from '../../assets/images/headerLogo.svg';
import MediaQuery from 'react-responsive';
import { isDesktop, isLargeDesktop, untilLargeDesktop } from '../../helper/mediaQueries';
import { connect } from "react-redux";
import Avatar from 'material-ui/Avatar';
import Logout from '../Logout';
import PropTypes from 'prop-types';

import {
    currentLevelName,
    currentLevelImage,
} from '../../helper/Helper';
import Flex from '../../components/Flex';

class Header extends Component {
    static propTypes = {
        logonEnabled:  PropTypes.string,
    };
    render() {
        let {
            currentLevelImage,
            isLoggedIn,
            isOnSurvey,
            location,
            logonEnabled
        } = this.props;
        return (
            <AppBar position="static" className="app__header">
                <Toolbar className="app__header--content">
                    <a
                        className="header__link header__link--title"
                        id="headerLink"
                        href="/prc/studentExperience.html"
                    >
                        <img src={LogoImgSrc} width={60} height={45} alt="NSW Department of Education logo" />
                        <MediaQuery query={isLargeDesktop}>
                            <h1>NSW Premier's Reading Challenge</h1>
                        </MediaQuery>
                        <MediaQuery query={untilLargeDesktop}>
                            <h1>NSW PRC</h1>
                        </MediaQuery>
                    </a>
                    {isOnSurvey? null :
                        <Flex just='e' align='c'>
                            {location.pathname === '/' ?
                                <a href="/prc/studentExperience.html" className="header__link">Home</a> :
                                <Link to="/" className="header__link">Home</Link>
                            }
                            <Link to="/rules" className="header__link">Rules</Link>
                            {isLoggedIn && (
                                <MediaQuery query={isDesktop}>
                                    <Logout className="header__link" />
                                </MediaQuery>
                            )}
                            {isLoggedIn ? (

                                <Link to="/profile" className="header__link header__user--logo">
                                    <Avatar
                                        src={currentLevelImage}
                                        alt="My progress page"/>
                                </Link>
                            ) : (logonEnabled[1]=='true')?(
                                <a href="/prc/logon.html" className="header__link">Log in</a>
                            ):''}
                        </Flex>
                    }
                </Toolbar>
            </AppBar>
        );
    }
}
const mapStateToProps = state => {
    const currentName = currentLevelName(state.user.readList.length, _.get(state, 'student.studentDetails.gradeName'))
    return {
        isLoggedIn: !!_.get(state, 'student.studentDetails.studentId'),
        currentLevelImage: currentLevelImage (currentName, false),
        logonEnabled: state.user.logonEnabled,
    }
};

export default withRouter(connect(
    mapStateToProps,
)(Header))

